import { defineStore } from "pinia"
import { ref } from "vue"
import axios from "axios"

/**
 * This store contains generic info on the server, metadata, and serves as a
 * cache for some information that has to be dynamically fetched.
 */
export const useGeneralStore = defineStore("general", () => {
  const appName = ref("Zettlr Web")
  const tagline = ref("European sovereign web-based infrastructure for collaborative authoring.")
  const termsOfService = ref("No terms of service provided.")
  const signupEnabled = ref(false)
  const exportsEnabled = ref(false)

  axios.post("/api/request-capabilities")
    .then(response => {
      appName.value = response.data.appName
      tagline.value = response.data.tagline
      signupEnabled.value = response.data.signupEnabled
      exportsEnabled.value = response.data.exportsEnabled
      termsOfService.value = response.data.termsOfService
    })
    .catch(err => {
      console.error("Could not retrieve Server capabilities! This is a bug", err)
    })
  
  return { appName, tagline, termsOfService, signupEnabled, exportsEnabled }
})
